<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [canGoBack]="true"
    [class]="extraClass"
    [title]="'Contact Support'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <tidy-row [align]="'center'">
      <tidy-text
        [body]="'Please contact us in the Concierge section for support, or visit our '">
      </tidy-text>
      <tidy-text
        (action)="goToDocumentation()"
        [body]="'Help Center'"
        class="link">
      </tidy-text>
      <tidy-text
        [body]="'.'">
      </tidy-text>
    </tidy-row>

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
